<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>

export default {
  mounted() {
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت درخواست های زمان بندی",
          link: "/loads",
          active: true,
        },
      ],
      isLoadingGrid: false,
      pageSize: 0,
      currentPage: 0,
      updateForm: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          field: "created_at",
          title: "تاریخ ایجاد درخواست",
          template: (e) => e.request && e.request.created_at ? this.$getJalaliDateTime(e.request.created_at) : "",
           width: "100px"
        },
        {
          title: "مبداء",
          template: (e) => ( e.request && e.request.origin && e.request.origin.name ? e.request.origin.name : " - "),
           width: "100px"
        },
        {
          title: "مقصد",
          template: (e) => ( e.request && e.request.destination && e.request.destination.name ? e.request.destination.name : " - "),
           width: "100px"
        },
        {
          title: "نوع بار",
          template: (e) => ( e.request && e.request.load_data && e.request.load_data.name ? e.request.load_data.name : " - "),
           width: "100px"
        },
        {
          title: "نوع ماشین",
          template: (e) => ( e.request && e.request.vehicle_type && e.request.vehicle_type.name ? e.request.vehicle_type.name : " - "),
           width: "100px"
        },
        {
          title: "تکرار زمان بندی",
          template: (e) => (e.type ? this.requestJobText(e.type) : " - "),
           width: "100px"
        },
        // {
        //   title: "زمان اجرا",
        //   template: (e) => (e.type_value ? this.$getJalaliDateTime(e.type_value) : " - "),
        // },
        {
          title: "آخرین زمان اجرا",
          template: (e) => (e.last_process_at ? this.$getJalaliDateTime(e.last_process_at) : " - "),
           width: "100px"
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
           width: "150px"
        },
      ];
    }
  },
  methods: {
      requestJobText(_requestJob) {
          let select = {
              1: { name: '۱ روز یک بار'},
              2: { name: '۲ روز یک بار'},
              3: { name: '۳ روز یک بار'},
              4: { name: '۴ روز یک بار'},
              5: { name: '۵ روز یک بار'},
              6: { name: '۶ روز یک بار'},
              7: { name: '۷ روز یک بار'},
              8: { name: 'تاریخ مشخصی تایید شده است'},
          };
          let text = select[_requestJob];
        return text ? text.name : '-';
      },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$persistClient(
        "get",
        `request-jobs`
      )
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    delete(e) {
      let request = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف این مورد اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `request-jobs/${request.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
